module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_simple_cp_gaseosas_lata_354_sp.d86dfbdb.png";